// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1VEXe","logo-svg":"Logo_logo-svg__H7m-O","logo-title":"Logo_logo-title__1mNP6"};